const sizesMap = {
    sm: 'sm',
    md: 'md',
    lg: 'lg',
}

export const defaultSize = 'md'

export const sizes = Object.keys(sizesMap)

export default sizesMap
